// ローディング判定
jQuery(window).on("load", function() {
  jQuery(function() {
    let swipeOption = {
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      preloadImages: false,
      lazy: {
        loadPrevNext: true
      },
      speed: 1500
    };
    new Swiper(".swiper.mv-img", swipeOption);
  });
});

// ローディング判定
jQuery(window).on("load", function() {
  // パスの取得
  jQuery(function() {
    let swipeOption = {
      loop: true,
      preloadImages: false,
      lazy: {
        loadPrevNext: true
      },
      autoplay: {
        // 自動再生
        delay: 5000,
        disableOnInteraction: false
      },
      speed: 1500,
      pagination: {
        el: ".swiper-pagination", //ページネーションの要素
        type: "bullets", //ページネーションの種類
        clickable: true //クリックに反応させる
      },
      navigation: {
        nextEl: ".swiper-button-next", // 「次へ」ボタン要素のクラス
        prevEl: ".swiper-button-prev" // 「前へ」ボタン要素のクラス
      }
    };
    new Swiper(".swiper.mv-file", swipeOption);
  });
});
